import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AnalyticsService } from '@app/shared/modules/analytics/services/analytics.service';
import {
  ChargePointLocation,
  ChargePointType,
  ChargingStationConfig,
} from 'src/app/modules/evc-small-biz/stores/small-biz-store.model';
import { AccordionComponent } from '../../../../component-lib/components/accordion/accordion.component';
import { ButtonStateEnum } from '../../../../component-lib/enums/button-state.enum';

@Component({
  selector: 'evsb-charging-station-flow',
  templateUrl: './charging-station-flow.component.html',
})
export class ChargingStationFlowComponent {
  @ViewChild(AccordionComponent) public accordion: AccordionComponent;

  @Input() public hasChosenChargingSpeed: boolean;
  @Input() public wantsAtLeastOneChargingStation: boolean;
  @Input() public hasChosenPlacement: boolean;
  @Input() public hasCompletedFlow: boolean;
  @Input() public model: ChargingStationConfig;
  public steps = [1, 2, 3];

  @Output() public solutionChange = new EventEmitter<ChargingStationConfig>();

  private placement30Map: Record<ChargePointLocation, ChargePointLocation> = {
    [ChargePointLocation.wallInside30]: ChargePointLocation.wallInside30,
    [ChargePointLocation.wallInside50]: ChargePointLocation.wallInside30,
    [ChargePointLocation.wallOutside30]: ChargePointLocation.wallOutside30,
    [ChargePointLocation.wallOutside50]: ChargePointLocation.wallOutside30,
    [ChargePointLocation.poleOutside30]: ChargePointLocation.poleOutside30,
    [ChargePointLocation.poleOutside50]: ChargePointLocation.poleOutside30,
  };

  private placement50Map: Record<ChargePointLocation, ChargePointLocation> = {
    [ChargePointLocation.wallInside30]: ChargePointLocation.wallInside50,
    [ChargePointLocation.wallInside50]: ChargePointLocation.wallInside50,
    [ChargePointLocation.wallOutside30]: ChargePointLocation.wallOutside50,
    [ChargePointLocation.wallOutside50]: ChargePointLocation.wallOutside50,
    [ChargePointLocation.poleOutside30]: ChargePointLocation.poleOutside50,
    [ChargePointLocation.poleOutside50]: ChargePointLocation.poleOutside50,
  };

  constructor(private analyticsService: AnalyticsService) {}

  public get stateForCurrentChoice(): ButtonStateEnum {
    return this.hasChosenChargingSpeed ? ButtonStateEnum.enabled : ButtonStateEnum.disabled;
  }

  public goToNextStep(stepIndex: number) {
    this.accordion.next(stepIndex);
  }

  updateSolution() {
    if (this.wantsAtLeastOneChargingStation) {
      this.solutionChange.emit({
        type: this.model.type,
        location: this.mapPlacementFromSpeed(this.model.location, this.model.type),
        smart: this.model.smart,
        amount: this.model.amount,
      });
    }
  }

  public onPanelOpen(panel: string) {
    this.analyticsService.push({
      event: 'b-to-b-ev-simulator-flow',
      eventCategory: 'b-to-b-ev-simulator',
      eventAction: 'step-charging-station',
      eventLabel: panel,
    });
  }

  private mapPlacementFromSpeed(placement: ChargePointLocation, speed: ChargePointType): ChargePointLocation {
    switch (speed) {
      case ChargePointType.connect30:
      case ChargePointType.connect30Pro:
        return this.placement30Map[placement];
      case ChargePointType.connect50:
      case ChargePointType.connect50Pro:
        return this.placement50Map[placement];
    }
  }
}
